import type {ReactElement} from 'react';
import { useEffect} from 'react';
import {initFonts} from '@Libraries/font-library';

interface BasePosterEditingFontOptionProps {
  children: ReactElement<any>;
}

export function BasePosterEditingFontOption({...props}: BasePosterEditingFontOptionProps): ReactElement<any> {
  useEffect(() => {
    initFonts().catch(() => {
      window.PMW.openErrorModal({
        message: window.i18next.t('pmwjs_error_message'),
      });
    });
  }, []);

  return props.children;
}
